import { Toaster } from 'sonner';
import { ErrorBoundary } from '@dukanti/shared';
import { QueryProvider } from './providers/query-provider';
import { I18nProvider } from './providers/i18n-provider';
import { AdminLocalePreferenceSync } from './providers/admin-locale-preference-sync';
import { AppRouter } from './routes';

// Nesting order is load-bearing: i18n > query > error-boundary > router.
// The default ErrorBoundary fallback uses `t()` from react-i18next, so the
// I18nProvider must be above it in the tree.
//
// <Toaster /> (sonner) is mounted inside I18nProvider so translated
// messages reach it, and inside QueryProvider so mutations can call
// `toast.success()` / `toast.error()` after settling. Position is
// `top-center` to read naturally for both RTL (ar/he) and LTR (en).
export function App() {
  return (
    <I18nProvider>
      <QueryProvider>
        <AdminLocalePreferenceSync />
        <ErrorBoundary>
          <AppRouter />
          <Toaster position="top-center" richColors closeButton />
        </ErrorBoundary>
      </QueryProvider>
    </I18nProvider>
  );
}
